const REGEX_PHONE = /\(\d{2}\) \d{4,5}-\d{4}/

export default function () {
  return this.test('date', 'Esse campo deve ser um telefone válido', function (value) {
    return typeof value === 'string'
      ? REGEX_PHONE.test(value)
      : true
  })
}
